import { render, staticRenderFns } from "./CommentsRatingCardWrapper.vue?vue&type=template&id=2ca5a708&scoped=true&"
import script from "./CommentsRatingCardWrapper.vue?vue&type=script&lang=js&"
export * from "./CommentsRatingCardWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CommentsRatingCardWrapper.vue?vue&type=style&index=0&id=2ca5a708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca5a708",
  null
  
)

export default component.exports